import * as React from 'react';
import moment from 'moment';
import propz from 'propz';
import { EventInvitationMessage } from 'Src/models/message';
import {
  ABSENCE_MESSAGE_REASON_SERVER_TO_CLIENT_MAPPING,
  ABSENCE_MESSAGE_INTERVAL_SERVER_TO_CLIENT_MAPPING
} from 'Src/consts/absenceMessage';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import './AbsenceRequsetCard.scss';

interface Props {
  item: EventInvitationMessage;
  onShowDetailsClick: (item: EventInvitationMessage) => void;
}

export const AbsenceRequestCard = (props: Props) => {
  const { item, onShowDetailsClick } = props;
  const { playerDetailsData } = item;

  const studentName = getFullName(playerDetailsData);
  const schoolLogo = propz.get(item, ['schoolData', 'pic'], '');
  const isSchoolLogoExist = schoolLogo !== '';
  const intervalAbsence = propz.get(item, ['intervalAbsence'], '');
  const absenceIntervalFormatted = ABSENCE_MESSAGE_INTERVAL_SERVER_TO_CLIENT_MAPPING[intervalAbsence];
  const reasonAbsence = propz.get(item, ['reasonAbsence'], '');
  const absenceReasonFormatted = ABSENCE_MESSAGE_REASON_SERVER_TO_CLIENT_MAPPING[reasonAbsence];
  const absenceDate = propz.get(item, ['dateAbsence'], '');
  const absenceDateFormatted = moment(absenceDate).format('DD/MM/YYYY');
  const isAuthorized = propz.get(item, ['isAuthorized']);
  const isAuthorizedFieldExist = typeof isAuthorized !== 'undefined';

  return (
    <article className="bAbsenceRequestCard">
      <header className="bAbsenceRequestCard__header">
        <div className="bAbsenceRequestCard__avatar" aria-hidden="true">
          {isSchoolLogoExist ? <img src={schoolLogo} alt="" /> : studentName.split(' ').map(part => part[0]).slice(0, 2).join('').toUpperCase()}
        </div>
        <div className="bAbsenceRequestCard__identity">
          <strong>{studentName}</strong>
          <span className={`bAbsenceRequestCard__status ${isAuthorizedFieldExist ? (isAuthorized ? 'is-approved' : 'is-declined') : ''}`}>
            {isAuthorizedFieldExist ? (isAuthorized ? 'Authorised' : 'Not authorised') : 'Pending'}
          </span>
        </div>
      </header>
      <div className="bAbsenceRequestCard__date">{absenceDateFormatted}</div>
      <div className="bAbsenceRequestCard__chips">
        <span>{absenceIntervalFormatted}</span>
        <span>{absenceReasonFormatted}</span>
      </div>
      <footer className="bAbsenceRequestCard__footer">
        <button type="button" onClick={() => onShowDetailsClick(item)}>View details</button>
      </footer>
    </article>
  );
};

AbsenceRequestCard.displayName = 'AbsenceRequestCard';



